import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import styled from "styled-components"
import { motion } from "framer-motion"

const StyledCustomImage = styled(GatsbyImage)`
  margin-bottom: 2rem;
  border-radius: ${props => (props.RoundedCorners ? "1rem" : "0px")};
`

function CustomImage(props) {
  const query = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          extension: { regex: "/(jpg)|(png)|(jpeg)/" }
          dir: { regex: "/nested_images/" }
        }
      ) {
        nodes {
          id
          name
          childImageSharp {
            gatsbyImageData(
              width: 1920
              placeholder: BLURRED
              formats: [PNG, WEBP]
            )
          }
        }
      }
    }
  `)

  const cardVariants = {
    offscreen: {
      opacity: 0,
      y: 20,
    },
    onscreen: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  }
  

  return (
    <motion.div
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, amount: 0.3 }}
      variants={cardVariants}
    >
      <StyledCustomImage
        image={
          query.allFile.nodes.find(image => image.name === props.name)
            .childImageSharp.gatsbyImageData
        }
        alt={props.alt}
        RoundedCorners={props.RoundedCorners}
      />
    </motion.div>
  )
}

export default CustomImage
